import { render } from "./PageHeader.vue?vue&type=template&id=d6ae9552&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d6ae9552"

export default script